import React from 'react';

interface IStatusCellProps {
	value: { status: string };
}

const STATUS_COLORS: Record<string, string> = {
	QUEUED: '#ffb400',
	RUNNING: '#3399ff',
	COMPLETED: '#2e7d32',
	FAILED: '#d32f2f',
	DEFAULT: '#000'
};

const StatusCell: React.FC<IStatusCellProps> = ({ value }) => {
	const color: string = STATUS_COLORS[value.status] || STATUS_COLORS.DEFAULT;
	return <span style={{ color, fontWeight: 'bold' }}>{value.status}</span>;
};

export default StatusCell;
